// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2RxpK","productName":"Table_productName__P6ohs"};